import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsWheelchairNormalSmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.16 9.38A2.82 2.82 0 108 12.19a2.81 2.81 0 00-2.84-2.81zm0 4.63A1.82 1.82 0 117 12.19 1.82 1.82 0 015.16 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32 10.09a3.49 3.49 0 00-3 1.76l-5.26-2.11a.5.5 0 00-.37.93l3.2 1.33h-4.83a4.94 4.94 0 10-.06 1h6.87a3.39 3.39 0 00-.06.64 3.52 3.52 0 103.51-3.51zm-15.16 6a3.92 3.92 0 113.92-3.92 3.91 3.91 0 01-3.92 3.94zm15.16 0a2.51 2.51 0 01-2.51-2.52 3.42 3.42 0 010-.45l2.29.92h.18a.5.5 0 00.19-1l-2.29-.92a2.52 2.52 0 112.1 3.9z"
  }));
});
SvgSportsWheelchairNormalSmall.defaultProps = {
  height: 24,
  width: 24
};
SvgSportsWheelchairNormalSmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsWheelchairNormalSmall;